module.exports = __webpack_public_path__ + "static/media/logisticsPark.180f4f12.jpg";